"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fxApiFactory = (http, prefix = '/fx') => ({
    getFXRateOnDate(fromCurrency, toCurrency, onDate) {
        const queryParams = onDate ? `?on_date=${onDate}` : '';
        return http.get(`${prefix}/rate/from/${fromCurrency}/to/${toCurrency}${queryParams}`);
    }
});
exports.default = fxApiFactory;
//# sourceMappingURL=fx.js.map